module.exports = __webpack_public_path__ + "img/ski_sub_title1.781db725.jpg";